import { z } from "zod";
import { UpdateCompanyRequest } from "@/api/generated/client/models";

// 1. Define Validations (The Schema)
// We map this to UpdateCompanyRequest from the API
// Note: The "at least one field" validation is handled in the mutation function
// where we check if updateData has any keys after filtering unchanged values
export const updateCompanySchema = z.object({
  name: z.string().min(1, "Company name is required").optional(),
  phone: z.string().nullish(),
  address: z.string().nullish(),
  domain: z.string().nullish(),
});

// 2. Infer Types
export type UpdateCompanyForm = z.infer<typeof updateCompanySchema>;

// 3. DRIFT PROTECTION
// Ensure our form stays compatible with Backend Types
// We check that our UpdateCompanyForm's fields match UpdateCompanyRequest
export type _BackendCheck = UpdateCompanyForm extends UpdateCompanyRequest ? true : false;
export type _BackendCheckReverse = UpdateCompanyRequest extends UpdateCompanyForm ? true : false;

